import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./ui/globals.css";
import "./ui/motion.css";
import "./ui/design2026/wo-base.css";
import "./ui/design2026/wo-shell.css";
import "./ui/crm.css";
import "./pwa/pwa.css";
import App from "./App";
import { AuthProvider } from "./auth/AuthContext";
import ErrorBoundary from "./ui/ErrorBoundary";
import { startNetwork } from "./pwa/network";
import { startPwa } from "./pwa/register";
import { browserLang, setLocale } from "./i18n";

// The phone app: connection watching, the service worker and the install prompt (src/pwa, docs/implemented-pwa.md).
startNetwork();
startPwa();
// The sign-in page in the browser's language until the person is known (their own language comes with the sign-in).
setLocale({ language: browserLang() });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>,
);
